import React from 'react'

import { useState, useEffect } from "react"
import { FiEdit, FiTrash2, FiPlus } from "react-icons/fi"
import { getGateways, createGateway, updateGateway, deleteGateway, getCommission, updateCommission } from "../utils/api"
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-toastify'


function CommsionSetup() {
    // Payment gateways data
    const [gateways, setGateways] = useState([])
    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const [editingGateway, setEditingGateway] = useState(null)
    const [formData, setFormData] = useState({
       commissionPercentage:null
    })

    // Delete confirmation
    const [deleteTarget, setDeleteTarget] = useState(null)

    // Fetch gateways on mount

    const { data: commissions, isLoading, refetch } = useQuery({
        queryKey: ['commission'],
        queryFn: getCommission
    })
    useEffect(() => {
        console.log(formData)
    }, [formData])


    // Handle all input changes
    const handleInputChange = (e) => {
        const { name, value, type: inputType, checked } = e.target
        setFormData((prev) => ({
            ...prev,
            [name]: inputType === "checkbox" ? checked : value,
        }))
    }

    // Features array handling
    const handleFeatureChange = (idx, value) => {
        setFormData((prev) => {
            const features = [...prev.features]
            features[idx] = value
            return { ...prev, features }
        })
    }

    const addFeature = () => setFormData((prev) => ({ ...prev, features: [...prev.features, ""] }))

    const removeFeature = (idx) =>
        setFormData((prev) => ({
            ...prev,
            features: prev.features.filter((_, i) => i !== idx),
        }))

    // Submit create or update
    const handleSubmit = async (e) => {
        e.preventDefault()
        const { commissionPercentage} = formData

        if (!commissionPercentage) {
            alert("Please Enter the percentage.")
            return
        }


        try {
           const res= await updateCommission(formData)
            refetch()
            toast.success(res.message)
            closeDialog()
        } catch (err) {
            console.error(err)
            alert(err.message || "Failed to save payment gateway")
        }
    }

    // Open form for edit
    const handleEdit = (gateway) => {
        setEditingGateway(gateway)
        setFormData({...formData,commissionPercentage:gateway.commissionPercentage})
        setIsDialogOpen(true)
    }

    // Delete flow
    const confirmDelete = (id) => setDeleteTarget(id)
    const handleConfirmDelete = async () => {
        try {
            await deleteGateway(deleteTarget)
            await fetchGateways()
        } catch (err) {
            console.error(err)
        } finally {
            setDeleteTarget(null)
        }
    }

    // Dialog controls
    const resetForm = () =>
        setFormData({
            commissionPercentage:null
        })

    const closeDialog = () => {
        resetForm()
        setEditingGateway(null)
        setIsDialogOpen(false)
    }

    const openDialog = () => {
        resetForm()
        setEditingGateway(null)
        setIsDialogOpen(true)
    }
    return (
        <div className="bg-white min-h-screen">
            <div className="w-full mx-auto p-6">
                {/* Header */}
                <div className="bg-white rounded-lg p-6 mb-6 shadow-sm">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-6 w-6 text-white"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                                    />
                                </svg>
                            </div>
                            <div>
                                <h1 className="text-2xl font-bold text-gray-800">
                                    Commission Settings
                                </h1>
                                <p className="text-gray-500 text-sm">
                                    Configure platform commission rates and payment distribution.
                                </p>
                            </div>

                        </div>

                      
                    </div>
                </div>

                {/* Gateways Table */}
                <div className="overflow-x-auto bg-white rounded-xl border border-gray-200 shadow-sm">
                    <table className="w-full">
                        <thead className="bg-gray-50 border-b border-gray-200">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                                    #
                                </th>

                                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                                    Commission Percentage
                                </th>

                                <th className="px-6 py-3 text-center text-xs font-semibold text-gray-500 uppercase tracking-wider">
                                    Actions
                                </th>
                            </tr>
                        </thead>

                        <tbody className="divide-y divide-gray-100">
                            {isLoading ? (
                                <tr>
                                    <td colSpan={3} className="px-6 py-6 text-center text-sm text-gray-400">
                                        Loading commission settings...
                                    </td>
                                </tr>
                            ) : commissions?.data ? (
                                <tr className="hover:bg-gray-50 transition-colors">
                                    <td className="px-6 py-4 text-sm text-gray-600">1</td>

                                    <td className="px-6 py-4">
                                        <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-emerald-100 text-emerald-700">
                                            {commissions.data[0].commissionPercentage}%
                                        </span>
                                    </td>

                                    <td className="px-6 py-4 text-center">
                                        <button
                                            onClick={() => handleEdit(commissions.data[0])}
                                            className="inline-flex items-center justify-center p-2 rounded-lg text-blue-600 hover:bg-blue-50 hover:text-blue-800 transition"
                                            title="Edit commission"
                                        >
                                            <FiEdit className="h-5 w-5" />
                                        </button>
                                    </td>
                                </tr>
                            ) : (
                                <tr>
                                    <td colSpan={3} className="px-6 py-6 text-center text-sm text-gray-400">
                                        No commission settings found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

            </div>

            {/* Add/Edit Modal */}
            {isDialogOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4"
                    onClick={closeDialog}
                >
                    <div
                        className="bg-white rounded-lg w-full max-w-lg max-h-[90vh] overflow-y-auto p-6"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2 className="text-xl font-semibold text-gray-800 mb-4">
                            Edit Commission
                        </h2>
                        <form onSubmit={handleSubmit} className="space-y-4">
                            {/* Name */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Commission Percentage (%)</label>
                                <input
                                    type="number"
                                    name="commissionPercentage"
                                    value={formData.commissionPercentage}
                                    onChange={handleInputChange}
                                    required
                                    className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>

    
             

                            {/* Save / Cancel */}
                            <div className="flex gap-2 pt-4">
                                <button type="submit" className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-md">
                                    Save
                                </button>
                                <button
                                    type="button"
                                    onClick={closeDialog}
                                    className="flex-1 border border-gray-300 text-gray-700 py-2 rounded-md hover:bg-gray-50"
                                >
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

          
        </div>
    )
}

export default CommsionSetup
